<template>
  <div>
    <b-row v-if="!success && !error">
      <b-col md="7" lg="5" class="mt-5 mx-auto">
        <b-form @submit.prevent="onSubmit" id="create-form">
          <div class="content">
            <h4>{{ labels.greeting }}</h4>
            <p>{{ labels.info }}</p>
          </div>
          <b-form-group :class="{ formLoading: isLoading }">
            <md-field>
            {{labels.username}}
            </md-field>
            <md-field @change="previewFiles">
              <label>Adjunta tu archivo .xlsx</label>
              <md-file v-model="metaDataFile" @change="previewFiles" multiple/>
            </md-field>
            <b-button type="submit" id="login-btn">{{ labels.login }}</b-button>
          </b-form-group>
          <div class="loadingSpinner" :class="{ active: isLoading }">
            <b-spinner></b-spinner>
          </div>
        </b-form>
      </b-col>
    </b-row>
    <b-container v-else class="pt-5">
      <b-col md="2" class="mx-auto">
        <div
          class="success-svg mb-4"
          :class="{ active: success }"
          v-if="!error"
        >
          <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 496 496"
            style="enable-background:new 0 0 496 496;"
            xml:space="preserve"
          >
            <path
              d="M248,0C111.033,0,0,111.033,0,248s111.033,248,248,248s248-111.033,248-248C495.841,111.099,384.901,0.159,248,0z
                     M248,480C119.87,480,16,376.13,16,248S119.87,16,248,16s232,103.87,232,232C479.859,376.072,376.072,479.859,248,480z"
              style="fill: #00ad7e"
            />
            <path
              d="M370.344,158.344L208,320.688l-82.344-82.344c-3.178-3.07-8.242-2.982-11.312,0.196c-2.994,3.1-2.994,8.015,0,11.116
                    l88,88c3.124,3.123,8.188,3.123,11.312,0l168-168c3.07-3.178,2.982-8.242-0.196-11.312
                    C378.359,155.35,373.444,155.35,370.344,158.344z"
              style="fill: #00ad7e"
            />
          </svg>
        </div>
        <div class="success-svg mb-4" :class="{ active: error }" v-else>
          <svg
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 52 52"
            style="enable-background:new 0 0 52 52;"
            xml:space="preserve"
            sodipodi:docname="error.svg"
            inkscape:version="0.92.4 (5da689c313, 2019-01-14)"
          >
            <metadata id="metadata43">
              <rdf:RDF
                ><cc:Work rdf:about=""
                  ><dc:format>image/svg+xml</dc:format
                  ><dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage"/><dc:title></dc:title></cc:Work
              ></rdf:RDF>
            </metadata>
            <defs id="defs41" />
            <sodipodi:namedview
              pagecolor="#ffffff"
              bordercolor="#666666"
              borderopacity="1"
              objecttolerance="10"
              gridtolerance="10"
              guidetolerance="10"
              inkscape:pageopacity="0"
              inkscape:pageshadow="2"
              inkscape:window-width="1920"
              inkscape:window-height="1013"
              id="namedview39"
              showgrid="false"
              inkscape:zoom="4.5384615"
              inkscape:cx="26"
              inkscape:cy="26"
              inkscape:window-x="-9"
              inkscape:window-y="-9"
              inkscape:window-maximized="1"
              inkscape:current-layer="Capa_1"
            />
            <g id="g6" style="fill:#ee6363;fill-opacity:0.94117647">
              <path
                d="M26,0C11.664,0,0,11.663,0,26s11.664,26,26,26s26-11.663,26-26S40.336,0,26,0z M26,50C12.767,50,2,39.233,2,26   S12.767,2,26,2s24,10.767,24,24S39.233,50,26,50z"
                id="path2"
                style="fill-opacity:0.94117647"
              />
              <path
                d="M35.707,16.293c-0.391-0.391-1.023-0.391-1.414,0L26,24.586l-8.293-8.293c-0.391-0.391-1.023-0.391-1.414,0   s-0.391,1.023,0,1.414L24.586,26l-8.293,8.293c-0.391,0.391-0.391,1.023,0,1.414C16.488,35.902,16.744,36,17,36   s0.512-0.098,0.707-0.293L26,27.414l8.293,8.293C34.488,35.902,34.744,36,35,36s0.512-0.098,0.707-0.293   c0.391-0.391,0.391-1.023,0-1.414L27.414,26l8.293-8.293C36.098,17.316,36.098,16.684,35.707,16.293z"
                id="path4"
                style="fill-opacity:0.94117647"
              />
            </g>
            <g id="g8"></g>
            <g id="g10"></g>
            <g id="g12"></g>
            <g id="g14"></g>
            <g id="g16"></g>
            <g id="g18"></g>
            <g id="g20"></g>
            <g id="g22"></g>
            <g id="g24"></g>
            <g id="g26"></g>
            <g id="g28"></g>
            <g id="g30"></g>
            <g id="g32"></g>
            <g id="g34"></g>
            <g id="g36"></g>
          </svg>
        </div>
      </b-col>
      <b-col md="8" class="mx-auto justify-content-around">
        <h4 v-if="errorMessage">{{labels.error}}</h4>
        <span
          type="button"
          id="reset-btn"
          v-if="success"
          @click="resetForm()"
          >{{ labels.new }}</span
        >
        <span
          type="button"
          id="check-btn"
          v-if="error"
          @click="checkForm()"
          >{{ labels.validate }}</span
        >
        <span
          type="button"
          id="resend-btn"
          v-if="error"
          @click="onSubmit()"
          >{{ labels.try }}</span
        >
      </b-col>
    </b-container>

    <div>
    
  </div>

  </div>
</template>

<script>

import Company from "@/services/Company";
import XLSX from 'xlsx';

export default {
  data: () => ({
    isLoading: false,
    success: false,
    error: false,
    errorMessage: false,
    metaDataFile: null,
    archivo: [],
    archivos: [],
    arrCalculos:{},
    month: '',
    year: ''
  }),
  methods: {
    previewFiles(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.createFile(files);
        },

    createFile(files) {
      var vm = this;
      //for (var index = 0; index < files.length; index++) {
        var reader = new FileReader();
        reader.onload = function(event) {
          var data = event.target.result;
          var workbook = XLSX.read(data, {type: 'binary', cellDates:true});
          let sheetName = workbook.SheetNames[0]
          let worksheet = workbook.Sheets[sheetName];
          vm.archivos = XLSX.utils.sheet_to_json(worksheet, {header:1,dateNF:'dd"."mm"."yyyy'});
        }
        reader.readAsBinaryString(files[0]);
      //}
    },
    calculos(liquidacion){
      this.arrCalculos.CLIENTE = liquidacion[4];
      this.arrCalculos.LOTES = liquidacion[9];
      this.arrCalculos.SACOS = liquidacion[16];
      this.arrCalculos.KILOS = liquidacion[14];

      this.arrCalculos.DENOMINACION = "";
      this.arrCalculos.PRODUCTO = "";
      this.arrCalculos.SUBPRODUCTO = "";
      this.arrCalculos.MATERIAL = "";

      this.arrCalculos.ORGANIZACION = liquidacion[25];
      this.arrCalculos.EMBARQUE = liquidacion[2].toLocaleDateString('es-CO');
      this.arrCalculos.FECHAVENTA = liquidacion[1].toLocaleDateString('es-CO');
      this.arrCalculos.FACTURACION = liquidacion[18];
      if (liquidacion[22]){this.arrCalculos.FECHACOMPRA = liquidacion[22].toLocaleDateString('es-CO') || 0;}
      else{this.arrCalculos.FECHACOMPRA = ''}
      
      var date1 = this.arrCalculos.FECHAVENTA.split("/")
      var date2 = this.arrCalculos.FECHACOMPRA.split("/")
      
      var day1 = 0;
      var day2 = 0;
      day1 = parseInt(date1[0])+parseInt(date1[1])*30+parseInt(date1[2])*365;
      day2 = parseInt(date2[0])+parseInt(date2[1])*30+parseInt(date2[2])*365;

      this.arrCalculos.COBERTURA = day2-day1;
      this.arrCalculos.PRIMAFTUSD = '';
      this.arrCalculos.PRIMAORG = '';
      this.arrCalculos.BOLSAVENTA = liquidacion[11];
      this.arrCalculos.BOLSACOMPRA = liquidacion[26];

      this.arrCalculos.DIFERENCIALVENTA = liquidacion[10];
      this.arrCalculos.FIJACIONBOLSA = parseFloat(this.arrCalculos.BOLSACOMPRA) + parseFloat(this.arrCalculos.DIFERENCIALVENTA);
      this.arrCalculos.TRMCOMPRA = liquidacion[32];
      
      // Costo mínimo Duda
      let prev = parseFloat(liquidacion[18])/parseFloat(this.arrCalculos.TRMCOMPRA);
      let factorC = 1.54322;
      this.arrCalculos.COSTOMINCTVS = parseFloat(prev)/factorC;
      this.arrCalculos.IGCOBERTURA = parseFloat(this.arrCalculos.BOLSACOMPRA) - parseFloat(this.arrCalculos.BOLSAVENTA);
      
      this.arrCalculos.IEXPOUSD = '';
      this.arrCalculos.IFINALUSD = '';
      this.arrCalculos.IEXPOCOP = '';
      this.arrCalculos.IFINALCOP = '';

      //this.arrCalculos.IEXPOUSD = parseFloat(this.arrCalculos.FACTURACION) - parseFloat(this.arrCalculos.PRIMAFTUSD||0);
      //this.arrCalculos.IFINALUSD = parseFloat(this.arrCalculos.IGCOBERTURA) + parseFloat(this.arrCalculos.IEXPOUSD||0);
      //this.arrCalculos.IEXPOCOP = (parseFloat(this.arrCalculos.KILOS)/parseFloat(this.arrCalculos.SACOS)*2.2046/100)*parseFloat(this.arrCalculos.IEXPOUSD)*parseFloat(this.arrCalculos.SACOS)*parseFloat(this.arrCalculos.TRMCOMPRA);
      //this.arrCalculos.IFINALCOP = parseFloat(this.arrCalculos.IGCOBERTURA)*parseFloat(this.arrCalculos.TRMCOMPRA)*factorC*parseFloat(this.arrCalculos.SACOS)*parseFloat(this.arrCalculos.IEXPOCOP);
      //this.arrCalculos.PRIMAFT = ((parseFloat(this.arrCalculos.KILOS)/parseFloat(this.arrCalculos.SACOS)*2.2046)/100)*parseFloat(this.arrCalculos.SACOS)*parseFloat(this.arrCalculos.PRIMAFT)*parseFloat(this.arrCalculos.TRMCOMPRA);

      this.arrCalculos.PRECIOCE = liquidacion[33];
      this.arrCalculos.PRIMAFT = '';
      if(parseFloat(this.arrCalculos.COSTOMINCTVS)<140){
        this.arrCalculos.RP140 = 140 - parseFloat(this.arrCalculos.COSTOMINCTVS);
      }else{this.arrCalculos.RP140 = 0;}

      this.arrCalculos.RP = (parseFloat(this.arrCalculos.RP140)*2.2046*parseFloat(this.arrCalculos.KILOS)*parseFloat(this.arrCalculos.TRMCOMPRA)/100)-5232.69;
      this.arrCalculos.COSTOLIBRAS = (parseFloat(this.arrCalculos.PRECIOCE)/parseFloat(this.arrCalculos.TRMCOMPRA))/parseFloat(this.arrCalculos.SACOS)/factorC;

      this.arrCalculos.COSTOCONT = '';
      this.arrCalculos.RELIQUIDACION = (parseFloat(this.arrCalculos.RP)/parseFloat(this.arrCalculos.TRMCOMPRA))/(parseFloat(this.arrCalculos.KILOS))/2.2046*100;
      
      this.arrCalculos.COSTOTOTAL = '';
      this.arrCalculos.UTCTVUSD = '';
      this.arrCalculos.UTCOP = '';

      //this.arrCalculos.COSTOTOTAL = parseFloat(this.arrCalculos.COSTOLIBRAS) + parseFloat(this.arrCalculos.COSTOCONT) + parseFloat(this.arrCalculos.RELIQUIDACION);
      //this.arrCalculos.UTCTVUSD = parseFloat(this.arrCalculos.IFINALUSD) - parseFloat(this.arrCalculos.COSTOTOTAL);
      //this.arrCalculos.UTCOP = (parseFloat(this.arrCalculos.KILOS)/100)*(parseFloat(this.arrCalculos.UTCTVUSD)+parseFloat(this.arrCalculos.TRMCOMPRA))*2.2046;
      this.arrCalculos.COSTOS = 16;

      this.arrCalculos.VRCOMPRA = parseFloat(this.arrCalculos.BOLSACOMPRA) - parseFloat(this.arrCalculos.COSTOS);
      this.arrCalculos.VRCOMPRASACO = parseFloat(this.arrCalculos.VRCOMPRAS)*factorC;
      this.arrCalculos.VRCALCSACO = parseFloat(this.arrCalculos.VRCOMPRASACO)*parseFloat(this.arrCalculos.SACOS)*parseFloat(this.arrCalculos.TRMCOMPRA);
      this.arrCalculos.DIFCOMPRA = (parseFloat(this.arrCalculos.PRECIOCE)-parseFloat(this.arrCalculos.VRCALCSACO))/parseFloat(this.arrCalculos.TRMCOMPRA);
      this.arrCalculos.DIFCOMPRACTVS = parseFloat(this.arrCalculos.DIFCOMPRA)/factorC/parseFloat(this.arrCalculos.SACOS);
      
      this.arrCalculos.DIFVENTACTVS = '';
      this.arrCalculos.UTPERDIFERENCIAL = '';
      this.arrCalculos.UTCONTABLE = '';
      this.arrCalculos.UTDIFERENCIAL = '';
      this.arrCalculos.DIFERENCIA = '';
      //this.arrCalculos.DIFVENTACTVS = parseFloat(this.arrCalculos.IFINALUSD)-parseFloat(this.arrCalculos.BOLSACOMPRA);
      //this.arrCalculos.UTPERDIFERENCIAL = parseFloat(this.arrCalculos.DIFVENTACTVS) - parseFloat(this.arrCalculos.DIFCOMPRACTVS);
      //this.arrCalculos.UTCONTABLE = parseFloat(this.arrCalculos.IFINALUSD)-parseFloat(this.arrCalculos.COSTOTOTAL);
      //this.arrCalculos.UTDIFERENCIAL = parseFloat(this.arrCalculos.COSTOS) - parseFloat(this.arrCalculos.COSTOCONT) + parseFloat(this.arrCalculos.UTPERDIFERENCIAL);
      //this.arrCalculos.DIFERENCIA = parseFloat(this.arrCalculos.UTCONTABLE) - parseFloat(this.arrCalculos.UTDIFERENCIAL);

    },
    async onSubmit() {
      this.isLoading = true;
      for (var j=1; j<this.archivos.length; j++){
        //let j = 1
        //console.log(this.archivos[j]);
        this.calculos(this.archivos[j]);
        //console.log(this.arrCalculos);
        //console.log(this.archivos[0])
        //this.arrCalculos = {}
        var index2 = this.arrCalculos.FECHAVENTA.indexOf('/')
        //var index3 = this.arrCalculos.FECHAVENTA.indexOf('/', index2)
        this.month = this.arrCalculos.FECHAVENTA.slice(index2+1, -5)
        this.year = this.arrCalculos.FECHAVENTA.slice(-4)

        let liquidacion = {
          username : this.labels.username,
          archivo : this.archivos[j],
          arrCalculos : this.arrCalculos,
          month : this.month,
          year : this.year,
          extraFields: {}
        }
        console.log(liquidacion)
        try{
          await Company.createCompany(liquidacion)
          this.success = true;
          this.error = false;
          this.errorMessage = false;
        }
        catch(err){
          this.success = false;
          this.error = true;
          if(err.response.status == 412){
            this.errorMessage = true;
          }
        }
          /*
          .then(() => {
            this.success = true;
            this.error = false;
              this.errorMessage = false;
          })
          .catch((err) => {
            this.success = false;
            this.error = true;
            if(err.response.status == 412){
              this.errorMessage = true
            }
          })
          .finally(() => {
            this.isLoading = false;
          });*/
      }
      this.isLoading = false;
    },
    checkForm: function() {
      this.error = false;
    },
    resetForm: function() {
      this.form.email = "";
      this.form.language = "";
      this.success = false;
      this.error = false;
    }
    },
  computed: {
    
    labels() {
      if (this.$store.state._language == "es-ES") {
        return {
          greeting: "Agrega tu archivo de Liquidación (FLO)",
          info: "",
          username: this.$store.state.userName,
          email: "Correo electrónico",
          language: "Idioma que maneja la compañia",
          login: "Subir",
          new: "Subir otro archivo",
          try: "Volver a intentar",
          validate: "Validar el formulario",
          error: "La compañia ya existe"
        };
      } else {
        return {
          greeting: "Let's Create a New Company",
          info: "Fill the fields",
          companyName: "Company Name",
          email: "Email address",
          language: "Company Email Language",
          login: "Create",
          new: "Create a new company",
          try: "Try again",
          validate: "Validate form",
          error: "Company already exists"
        };
      }
    },
  },
};
</script>

<style src="../main.css"></style>